import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getMyActivityLevelRequest: ['startDate', 'endDate', 'timezoneOffset'],
  getMyActivityLevelSuccess: ['response'],
  getMyActivityLevelFailure: null,

  getMyInfractionsRequest: ['startDate', 'endDate', 'timezoneOffset'],
  getMyInfractionsSuccess: ['response'],
  getMyInfractionsFailure: null,

  getInfractionsDetailsRequest: [
    'userId',
    'startDate',
    'endDate',
    'timezoneOffset',
    'currentPage',
    'pageSize',
    'search',
  ],
  getInfractionsDetailsSuccess: ['response'],
  getInfractionsDetailsFailure: null,

  getMySpottedVehiclesRequest: ['startDate', 'endDate', 'timezoneOffset'],
  getMySpottedVehiclesSuccess: ['response'],
  getMySpottedVehiclesFailure: null,

  getMyRepossessionsRequest: ['startDate', 'endDate', 'timezoneOffset'],
  getMyRepossessionsSuccess: ['response'],
  getMyRepossessionsFailure: null,

  getMyHoursWorkedRequest: ['startDate', 'endDate', 'timezoneOffset'],
  getMyHoursWorkedSuccess: ['response'],
  getMyHoursWorkedFailure: null,

  getDayShiftsRequest: ['userId', 'date', 'timezoneOffset'],
  getDayShiftsSuccess: ['response'],
  getDayShiftsFailure: null,

  getDayExtraneousTimesRequest: ['userId', 'date', 'timezoneOffset'],
  getDayExtraneousTimesSuccess: ['response'],
  getDayExtraneousTimesFailure: null,

  getMyCommissionsRequest: ['startDate', 'endDate', 'timezoneOffset'],
  getMyCommissionsSuccess: ['response'],
  getMyCommissionsFailure: null,

  getMyMissedOpportunitiesRequest: ['startDate', 'endDate', 'timezoneOffset'],
  getMyMissedOpportunitiesSuccess: ['response'],
  getMyMissedOpportunitiesFailure: null,

  // Clear all caches
  clearStatsRequest: null,
});

export const StatsTypes = Types;
export default Creators;
